import React from 'react';
import { Scan, LayoutTemplate, Car, Users, ClipboardList, Paperclip } from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab }) => {
    // 🔧 hidden: true로 설정된 메뉴는 숨김 (추후 복원 가능)
    const menuItems = [
        { id: 'viewer', label: 'OCR 검증', icon: Scan },
        { id: 'grid', label: '일괄 검증', icon: LayoutTemplate },
        { id: 'mapping', label: '차량등록', icon: Car },
        { id: 'legacy-registration', label: '거래처등록', icon: Users },
        { id: 'talkcloud', label: '톡클라우드', icon: Paperclip },
    ];

    return (
        <div className="w-[56px] bg-white border-r border-gray-200 flex flex-col items-center py-2 space-y-1 z-20 shadow-sm flex-shrink-0">
            {menuItems.filter(item => !item.hidden).map((item) => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;

                return (
                    <button
                        key={item.id}
                        onClick={() => setActiveTab(item.id)}
                        className={`
              w-12 h-12 flex flex-col items-center justify-center rounded-lg transition-all duration-200
              ${isActive
                                ? 'bg-blue-50 text-blue-600 border border-blue-200'
                                : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
                            }
            `}
                        title={item.label}
                    >
                        <Icon size={18} strokeWidth={isActive ? 2 : 1.5} className="mb-0.5" />
                        <span className={`text-[8px] font-medium leading-tight ${isActive ? 'font-bold' : ''}`}>
                            {item.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default Sidebar;

